<template>
  <div class="news-detail">
    <div class="defult_width ">
      <!-- hide -->
      <div class="location">{{language === 'E' ? 'Location：' : '当前位置：'}}<router-link to="/AboutMe">{{language === 'E' ? 'About Us' : '关于我们'}}</router-link> > <span>{{ detail.current.name }}</span></div>
      <!-- <div class="location">当前位置：<router-link to="/IndustryNews">关于我们</router-link> > <span>{{ detail.current.name }}</span></div> -->
      <div class="left">
        <h5>{{ detail.current.name }}</h5>
        <div class="time">{{language === 'E' ? 'Release Time：' : '发布时间：'}} {{ detail.current.time.year + '/' + detail.current.time.month}}</div>
        <div v-for="(item, key) in detail.current.html" :key="key">
          <img v-if="item.img" :src="item.img"  alt="">
          <p v-else-if="item.imgDetail" class="img-detail"> {{ item.imgDetail }} </p>
          <p class="p" v-else>
            {{ item }}
          </p>
        </div>
      </div>
      <div class="right">
        <div class="describe">
          <h5 class="right-title">
            {{language === 'E' ? 'Enterprise tenet' : '坤恒科技'}}
          </h5>
          <p>
            让我们的努力筑宽中国电子信息高速公路！
          </p>
          <p>———— 全体坤恒同仁</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import news from '@/datas/news'
import Enews from '@/EnglishData/news'
export default {
  name: 'ProductCenter',
  data () {
    const language = localStorage.getItem('language')
    let languageNews = null
    if (language && language === 'E') {
      languageNews = Enews
    } else {
      languageNews = news
    }
    const { companyNewsList } = languageNews
    return {
      detail: null,
      companyNewsList,
      language,
      productIndex: 0
    }
  },
  created () {
    let next = null; let pre = null
    let id = parseInt(this.$route.params.id)
    next = (id - 0) === 1 ? this.companyNewsList.length : (id - 0) - 1
    pre = (id - 0) === this.companyNewsList.length ? 1 : (id - 0) + 1
    let list = { current: null, preDetail: null, nextDetail: null }
    this.companyNewsList.forEach((item) => {
      if (item.id === id) {
        list.current = item
      }
      if (item.id === next) {
        list.nextDetail = item
      }
      if (item.id === pre) {
        list.preDetail = item
      }
    })
    this.detail = list
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.news-detail {
  padding: 0 0 50px;
  border-top: 1px solid #e5e5e5;
  background: #f9f9f9;
  overflow: hidden;
  .location {
    padding: 20px 0;
    text-align: left;
    a {
      color: #333;
    }
  }
  .left {
    width: 65%;
    margin-right: 5%;
    float: left;
    text-align: center;
    h5 {
      font-size: 20px;
      color: 000;
      line-height: 40px;
      font-weight: 800;
    }
    .time {
      text-align: right;
      color: #888;
      margin: 10px 0 20px;
    }
    .p {
      text-align: left;
      line-height: 30px;
      text-indent: 2em;
      margin-bottom: 20px;
    }
    .img-detail {
      text-align: center;
      line-height: 20px;
      margin: -10px 0 30px;
    }
    img {
      margin: 0 auto;
      max-width: 100%;
      margin-bottom: 20px;
    }
  }
  .right {
    width: 30%;
    float: right;
    text-align: left;
    .describe {
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      p {
        margin-top: 20px;
        &:last-child {
          text-align: right;
        }
      }
    }
    .right-title {
      font-size: 18px;
      padding-bottom: 15px;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      &::after {
        position: absolute;
        content: ' ';
        display: block;
        left: 0;
        bottom: -2px;
        width: 45px;
        height: 4px;
        background: #1e50ae;
      }
    }
    .list-box {
      margin-top: 20px;
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      li {
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          h5 {
            font-size: 16px;
            line-height: 30px;
            color: #1e50ae;
          }
          p {
            font-size: 14px;
            line-height: 24px;
          }
        }
        &:last-child {
          a {
            border: none;
          }
        }
      }
    }
  }
  .hide {
    .left {
      width: 100%;
    }
    .right {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutMe/detail.vue